import { ReactElement } from 'react';
import styled from 'styled-components';

import { ButtonsLayoutProps } from './button.d';
import { getButtonLayoutStyles } from './button.styles';

const StyledButtonsLayout = styled.div`
  ${getButtonLayoutStyles}
`;

export const ButtonsLayout = ({ children, className }: ButtonsLayoutProps): ReactElement => {
  return <StyledButtonsLayout className={`buttons-layout ${className}`}>{children}</StyledButtonsLayout>;
};
